module.exports = __webpack_public_path__ + "fonts/AlteDIN1451Mittelschrift.1bb25deb.ttf";